import React, { useCallback, useContext, useEffect, useRef } from "react";
import "./PublicPage.scss";
import { SliderSettings, TransportationMethod } from "../../Constant";
import Slider from "react-slick";
import { Grid } from "@mui/material";
import { Slide1 } from "./main-slide/Slide1";
import { Slide2 } from "./main-slide/Slide2";
import { Slide3 } from "./main-slide/Slide3";
import MyContext from "../../contexts/MyContext";
import TrainStationApiService from "../../adapters/xhr/TrainStationApiService";
import ClientSettingApiService from "../../adapters/xhr/ClientSettingApiService";
import { formatDate, formatDepartureDate, formatTime } from "../../Utils";
import Logo from "../../static/VL_Logo_CMYK_DarkBlue.png";
import StopApiService from "../../adapters/xhr/StopApiService";

export const PublicPage = (props) => {
  let sliderRef = React.createRef();
  const myContext = useContext(MyContext);

  const fetchTrainStations = useCallback(async () => {
    let response = await TrainStationApiService.getAll();
    if (response.isSuccess) {
      myContext.changeTrainStations(response.data);
    }
  }, []);

  const fetchStops = useCallback(async () => {
    let response = await StopApiService.getAll();
    if (response.isSuccess) {
      myContext.changeStops(response.data);
    }
  }, []);

  const fetchLines = useCallback(async () => {
    let response = await StopApiService.getAllLines();
    if (response.isSuccess) {
      myContext.changeLines(response.data);
    }
  }, []);

  const getClientAppSettings = useCallback(async () => {
    let response = await ClientSettingApiService.GetClientAppSettings();
    if (response.isSuccess) {
      myContext.changeTotalCostSEKMax(response.data.totalCostSEKMax);
      myContext.changeAllowFileUploadExtension(response.data.allowFileUploadExtension);
    }
  }, []);

  useEffect(() => {
    sliderRef.slickGoTo(myContext.activeSlide, false);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [myContext.activeSlide]);

  useEffect(() => {
    getClientAppSettings();
    if (!myContext.trainStations || myContext.trainStations.length === 0) fetchTrainStations();
    if (!myContext.stops || myContext.stops.length === 0) fetchStops();
    if (!myContext.lines || myContext.lines.length === 0) fetchLines();
  }, []);

  const fetchTrainDepartureTimeList = async () => {
    let response = await TrainStationApiService.getDepartureTimeList(
      myContext.departureStation.code,
      myContext.arrivalStation.code,
      null,
      formatDate(myContext.departureDate)
    );
    if (response.isSuccess) {
      let data = response.data
        .map((option, key) => {
          let rObj = {};
          rObj["key"] = key;
          rObj["value"] = formatTime(option);
          rObj["data"] = option;
          return rObj;
        })
        .sort((a, b) => {
          if (new Date(a.data) > new Date(b.data)) {
            return 1;
          }
          if (new Date(a.data) < new Date(b.data)) {
            return -1;
          }
          return 0;
        });
      myContext.changeDepartureTimeOptions(data);
    }
  };

  const fetchBusDepartureTimeList = async () => {
    let response = await StopApiService.getDepartureTimeList(
      myContext.departureStation.stopNumber,
      myContext.arrivalStation.stopNumber,
      myContext.line.number,
      formatDate(myContext.departureDate)
    );
    if (response.isSuccess) {
      let data = response.data
        .map((option, key) => {
          let rObj = {};
          rObj["key"] = key;
          rObj["value"] = formatTime(option);
          rObj["data"] = option;
          return rObj;
        })
        .sort((a, b) => {
          if (new Date(a.data) > new Date(b.data)) {
            return 1;
          }
          if (new Date(a.data) < new Date(b.data)) {
            return -1;
          }
          return 0;
        });
      myContext.changeDepartureTimeOptions(data);
    }
  };

  useEffect(() => {
    if (myContext.departureTimeOptions) myContext.changeDepartureTime(null);
  }, [myContext.departureTimeOptions]);

  useEffect(() => {
    if (myContext.departureDate && myContext.departureStation && myContext.arrivalStation && !myContext.departureTime) {
      if (myContext.transportationMethod == TransportationMethod.TRAIN) {
        fetchTrainDepartureTimeList();
        myContext.changeDepartureTime(null);
      }
      if (myContext.transportationMethod == TransportationMethod.BUS && myContext.line) {
        fetchBusDepartureTimeList();
        myContext.changeDepartureTime(null);
      }
    }
  }, [myContext.departureDate, myContext.departureStation, myContext.arrivalStation, myContext.line]);

  const setActiveSlide = (index) => {
    myContext.changeActiveSlide(index);
  };
  return (
    <MyContext.Consumer>
      {(context) => (
        <Grid container className="container custom padding top-2 bottom-2 left-0 right-0" justifyContent="center">
          <Grid item>
            <div hidden={context.activeSlide !== 0}>
              <img src={Logo} className="logo" alt="VL, logo" />
            </div>
            <Slider ref={(slider) => (sliderRef = slider)} {...SliderSettings} beforeChange={(_, next) => setActiveSlide(next)}>
              <Slide1 />
              <Slide2 />
              <Slide3 />
            </Slider>
          </Grid>
        </Grid>
      )}
    </MyContext.Consumer>
  );
};
